import { HugeiconsIcon } from "@hugeicons/react";
import { Tick02Icon } from "@hugeicons-pro/core-stroke-rounded";
import { Button, ButtonSize, ButtonVariant } from "shared/components";
import { useNavCustomization } from "../use-nav-customization";

export const CustomizeNavHeader = () => {
  const { isSaved, stopCustomizing } = useNavCustomization();

  return (
    <div className="flex h-14 w-full items-center gap-2 px-4">
      <div className="min-w-0 flex-1 space-y-0.5">
        <p className="text-sm font-bold text-content-1000">Customize menu</p>
        {isSaved ? (
          <p
            role="status"
            className="flex items-center gap-1 text-xs font-medium text-content-700"
          >
            <HugeiconsIcon icon={Tick02Icon} size={14} strokeWidth={2} />
            Saved
          </p>
        ) : (
          <p className="text-xs font-medium text-content-300">
            Saves automatically
          </p>
        )}
      </div>
      <Button
        variant={ButtonVariant.PRIMARY}
        size={ButtonSize.XS}
        HugeIcon={Tick02Icon}
        onClick={stopCustomizing}
      >
        Done
      </Button>
    </div>
  );
};
